import React, { useEffect, useState } from 'react';
import Thread from '../../components/thread/Thread';
import axios from 'axios';
import { deruptFeedContractAddress, stacksApi } from '../../lib/constants';
import './style.scss';
import MediaPlayer from '../../components/snackmediaplayer';

const Chime = ({ txId, setReplyOpen, userSettings }) => {
  const [hexValue, setHexValue] = useState();

  const [playList, setPlayList] = useState([]);
  const [openMediaPlayer, setOpenMediaPlayer] = useState(false);
  const [selectedChimeTx, setSelectedChimeTx] = useState(0);
  const [mediaCurrentTime, setMediaCurrentTime] = useState({ currentTime: 0, playorPaused: false, txId: '' });

  const fetchHexValue = async () => {
    try {
      const { data: { events } } = await axios.get(`${userSettings?.stacksApi || stacksApi}/extended/v1/tx/${txId}`);
      for (let i = 0; i < events.length; i++) {
        if (events[i].event_type === "smart_contract_log") {
          const { contract_log: { contract_id, value: { hex } } } = events[i];
          if (contract_id === deruptFeedContractAddress) {
            setHexValue(hex);
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchHexValue();
  }, []);

  return (
    <>
      <div className='chime-solo-page-wrapper'>
        {hexValue && <Thread baseTxId={txId} hex={hexValue} setReplyOpen={setReplyOpen} threading={true} userSettings={userSettings}
          playList={playList} setPlayList={setPlayList} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}
          openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
          index={0} selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx}
        />
        }
      </div>
      {(openMediaPlayer && playList.length > 0) ? <MediaPlayer openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer} playList={playList} setPlayList={setPlayList} selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx} setMediaCurrentTime={setMediaCurrentTime} /> : null}
    </>
  );
};

export default Chime;